<template>
  <b-modal
      id="modal-copy-nota"
      ref="modal"
      size="xl"
      title="Copiar dados de nota fiscal"
      title-class="font-18"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @hidden="$emit('hidden')">
    <div class="modal-body">
      <fieldset v-if="ultimaNota.length > 0" class="row border div-group">
        <legend class="div-group">Última nota fiscal emitida</legend>
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-nowrap table-centered mb-0">
              <tbody>
              <tr v-for="n in ultimaNota" :key="n.not_numero">
                <td class="border-0 border-white">
                  <h5 class="text-white font-size-12 mb-1">`</h5>
                  <p class="text-muted mb-0">
                    <a @click="$emit('selecionar', n.not_hash)" href="javascript:void(0);">Selecionar</a>
                  </p>
                </td>
                <td class="border-0 border-white">
                  <h5 class="text-truncate font-size-12 mb-1">Data/Hora</h5>
                  <p class="text-muted mb-0">{{ n.not_emissao | formatDateHora }}</p>
                </td>
                <td class="border-0 border-white">
                  <h5 class="text-truncate font-size-12 mb-1"> Número </h5>
                  <p class="text-muted mb-0">{{ n.not_numero }}</p>
                </td>
                <td class="border-0 border-white">
                  <h5 class="text-truncate font-size-12 mb-1"> Tomador </h5>
                  <p class="text-muted mb-0">{{ n.sep_razao_social_tomador }}</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </fieldset>
      <loader :loading="loading">
        <fieldset class="row border div-group">
          <legend class="div-group">Pesquisar nota fiscal</legend>
          <div class="col-md-3">
            <b-form-group label="Ano" label-for="fnot_emissao_ano">
              <input
                  id="fnot_emissao_ano"
                  v-model="filtro.not_emissao_ano"
                  v-mask="'####'"
                  type="text"
                  maxlength="4"
                  class="form-control"
                  placeholder="Ano">
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Números Finais" label-for="fnot_numero">
              <input
                  id="fnot_numero"
                  v-model="filtro.not_numero"
                  type="text"
                  maxlength="11"
                  class="form-control"
                  placeholder="Números após os zeros">
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="´" class="text-white">
              <button type="button" @click="pesquisar" class="mt-1 btn btn-sm btn-label btn-primary">
                <i class="bx bx-search label-icon"></i> Pesquisar
              </button>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <div v-if="resultadoPesquisa && resultadoPesquisa.length < 1"
                 class="alert alert-warning text-dark" role="alert">
              <h5>Nenhuma nota fiscal encontrada</h5>
              <p>Certifique-se de que o <b>Ano</b> e <b>Números Finais</b> estejam escritas corretamente.<br>
                Por exemplo:<br>
                Se o número da nota fiscal for <b>202200000000276</b> <br>
                No campo <b>Ano</b> você deve informar <b>2022</b><br>
                No campo <b>Números Finais</b> você deve informar <b>276</b><br></p>
            </div>
            <div class="table-responsive">
              <table class="table table-nowrap table-centered mb-0">
                <tbody>
                <tr v-for="n in resultadoPesquisa" :key="n.not_numero">
                  <td class="border-0 border-white">
                    <h5 class="text-white font-size-12 mb-1">`</h5>
                    <p class="text-muted mb-0">
                      <a @click="$emit('selecionar', n.not_hash)" href="javascript:void(0);">Selecionar</a>
                    </p>
                  </td>
                  <td class="border-0 border-white">
                    <h5 class="text-truncate font-size-12 mb-1">Data/Hora</h5>
                    <p class="text-muted mb-0">{{ n.not_emissao | formatDateHora }}</p>
                  </td>
                  <td class="border-0 border-white">
                    <h5 class="text-truncate font-size-12 mb-1"> Número </h5>
                    <p class="text-muted mb-0">{{ n.not_numero }}</p>
                  </td>
                  <td class="border-0 border-white">
                    <h5 class="text-truncate font-size-12 mb-1"> Tomador </h5>
                    <p class="text-muted mb-0">{{ n.sep_razao_social_tomador }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>
      </loader>
    </div>
    <template #modal-footer>
      <b-button @click="fechar" variant="outline-dark">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Loader from "@/components/widgets/loader";
import moment from "moment";

export default {
  name: "ModalCopiarNota",
  components: { Loader },
  props: {
    ultimaNota: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    ecoCodigo: { type: [String, Number], required: true },
  },
  data() {
    return {
      filtro: {
        nota_pagina: 1,
        not_emissao_ano: moment().format('YYYY'),
        not_numero: null,
      },
      resultadoPesquisa: null,
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    fechar() {
      this.$refs.modal.hide();
    },
    pesquisar() {
      this.$emit('pesquisar', this.filtro);
    },
    setResultado(dados) {
      this.resultadoPesquisa = dados;
    },
  },
};
</script>
